import React from 'react';

import type {
  TextComponent,
  Text as TextItem,
} from '../../../../../../core/data-sources/content-components/types.js';

import ListicleHeader from './ListicleHeader.js';
import List from '../Text/List.js';
import { RichTextElement } from '../../../../helpers/rich-text.js';
import {
  isListBlock,
  isTextBlock,
} from '../../../../../../core/data-sources/content-components/type-guards.js';

interface TextProps extends TextComponent {
  groupIndex?: number;
  isFact?: boolean;
}

const Text: React.FC<TextProps> = (props: TextProps) => {
  const { groupIndex } = props;
  const isLead = props.subtype === 'lead';

  return (
    <div>
      {props.paragraphs.map((paragraph, index) => {
        const value = isTextBlock(paragraph) && paragraph.text?.value;
        const isHeading = paragraph.blockType === 'heading';
        const hasItems = isListBlock(paragraph);

        if (isLead) {
          return (
            <p className="lead-text" key={`lead-${groupIndex}-${index}`}>
              {value}
            </p>
          );
        }
        if (isHeading && value) {
          return (
            <ListicleHeader
              value={value}
              key={`listicle-${groupIndex}-${index}`}
            />
          );
        }

        if (hasItems) {
          const items = paragraph.items;

          if (paragraph.blockType === 'list:unordered') {
            return (
              <List
                key={`unordered-list-${groupIndex}-${index}`}
                items={items}
                groupIndex={groupIndex}
              />
            );
          }

          return items.map((item: TextItem, index) => (
            <div
              key={`paragraph-${groupIndex}-${index}`}
              className={`paragraph ${groupIndex}-${index}`}
            >
              {props.isFact ? '' : '• '}
              <RichTextElement content={item} />
            </div>
          ));
        }

        return (
          <div
            key={`paragraph-${groupIndex}-${index}`}
            className={`paragraph ${groupIndex}-${index}`}
          >
            <RichTextElement content={paragraph.text} />
          </div>
        );
      })}
    </div>
  );
};

export default Text;
